import { createContext, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';
const LocaleContext = /*#__PURE__*/createContext({
  locale: 'en',
  localeFromUrl: '',
  defaultLoggedOutConfig: {},
  fallbackLoggedOutConfig: []
});
function LocaleProvider({
  children,
  locale = 'en',
  localeFromUrl,
  defaultLoggedOutConfig = {},
  fallbackLoggedOutConfig
}) {
  return /*#__PURE__*/jsx(LocaleContext.Provider, {
    value: {
      locale,
      localeFromUrl,
      defaultLoggedOutConfig,
      fallbackLoggedOutConfig
    },
    children: children
  });
}
const useLocaleContext = () => useContext(LocaleContext);
export { LocaleProvider, useLocaleContext };
//# sourceMappingURL=LocaleProvider.js.map
